import {
  ADD_TAX_INFO,
  APPLY_TRANSACTIONS_RULES,
  ASSIGN_CATEGORY,
  DELETE_TRANSACTION_ATTACHMENT,
  DELETE_TRANSACTION_CATEGORY,
  DELETE_TRANSACTIONS,
  GET_INVOICE_BY_INVOICE_NUMBER,
  GET_SUPPLIER_REFERENCES,
  GET_TRANSACTION_TAX_AMOUNT,
  GET_TAXTYPE_WITH_STATE_PROVINCE,
  GET_TRANSACTION_ATTACHMENT,
  IMPORT_TRANSACTION,
  LIST_ALL_TRANSACTIONS,
  LIST_TRANSACTION_CATEGORIES,
  REMOVE_DELETED_TRANSACTION,
  SAVE_TRANSACTION,
  SAVE_TRANSACTION_CATEGORY,
  SET_PROCESSING,
  STORE_ALL_TRANSACTION_CATEGORIES,
  STORE_ALL_TRANSACTIONS,
  STORE_FOUND_INVOICE,
  STORE_SUPPLIER_REFERENCES,
  STORE_TRANSACTION_ATTACHMENT,
  STORE_UPDATED_TRANSACTION,
  STORE_UPDATED_TAXINFO,
  STORE_TAXTYPE_WITH_STATE_PROVINCE,
  SAVE_AND_NAVIGATE_TO_CHILD_TRANSACTION,
  STORE_UPDATED_TRANSACTIONS,
  STORE_EDITING_TRANSACTION,
  NAVIGATE_TO_PARENT_TRANSACTION,
  SAVE_CHEQUE,
  STORE_UPDATED_CHEQUES,
  STORE_ALL_CHEQUES,
  LIST_ALL_CHEQUES,
  DELETE_CHEQUES,
  LIST_SHIPPING_SUMMARY,
  STORE_SHIPPING_SUMMARY,
  STORE_SHIPPING_SUMMARY_SETTINGS,
  LIST_SHIPPING_SETTINGS,
  SAVE_SHIPPING_SETTINGS,
  UPDATE_SHIPPING_SUMMARY,
  SAVE_STATEMENT_TAXES_TEMPLATE,
  LIST_STATEMENT_TAXES,
  PREVIEW_STATEMENT_TAXES,
  STORE_STATEMENT_TAXES_TEMPLATE,
  STORE_STATEMENT_TAXES_SUMMARY,
  LIST_STATEMENT_TAXES_TEMPLATE,
  IMPORT_CHEQUE,
  SAVE_LEDGER,
  STORE_ALL_LEDGERS,
  LIST_ALL_LEDGERS,
  LIST_LEDGERS_FOR_SETTINGS,
  STORE_LEDGERS_FOR_SETTINGS,
  LIST_ADD_LEDGERS,
  SAVE_TRANSACTION_LEDGER,
  DELETE_LEDGER_BY_YEAR,
  LEDGER_ENTRIES,
  PREVIEW_LEDGER_REFRESH,
  APPLY_LEDGER_REFRESH,
  STORE_LEDGER_PREVIEW,
  CLEAR_LEDGER_PREVIEW,
  CHECK_LEDGER_UPDATES,
  STORE_LEDGER_DESYNC,
  CLEAR_LEDGER_DESYNC,
  SAVE_LEDGER_DESYNC_STATUS,
  FETCH_TRANSACTIONS_LEDGER,
  STORE_TRANSACTIONS_LEDGER,
  VALIDATE_CHEQUE_NUMBER,
  START_LOADING,
  STOP_LOADING,
  LIST_PURCHASE_SUMMARY,
  STORE_PURCHASE_SUMMARY,
  DELETE_LEDGER,
  UPDATE_LEDGER,
  STORE_FTL_SUMMARY,
  LIST_FTL_SUMMARY,
  UPDATE_ENTRY,
  DELETE_ENTRY,
  STORE_LEDGER_ENTRY,
  GET_NOTE,
  STORE_NOTE,
  SAVE_NOTE,
  STORE_PREDEFINED_ENTRY,
  LIST_ALL_TRIAL_BALANCE,
  FETCH_TRIAL_BALANCE,
  STORE_TRIAL_BALANCE,
  LIST_LEDGER_AUDIT,
  STORE_LEDGER_AUDIT,
  SAVE_TRIAL_BALANCE,
  IMPORT_MARKETPLACE_SUMMARY,
  LIST_MARKETPLACE_SUMMARY,
  PREVIEW_MARKETPLACE_SUMMARY,
  STORE_MARKETPLACE_SUMMARY,
  MARKETPLACE_PROGRESS_SUMMARY,
  STORE_MARKETPLACE_PROGRESS_SUMMARY,
  STORE_MARKETPLACE_PROGRESS_SESSION,
  SAVE_MARKETPLACE_LEDGER,
  DELETE_LEDGER_BY_YEAR_AND_CURRENCY,
  SAVE_INCOME_STATEMENT,
  LIST_ALL_INCOME_STATEMENT,
  FETCH_INCOME_STATEMENT,
  STORE_INCOME_STATEMENT,
  LIST_INCOME_STATEMENT_MAPPING_TEMPLATE,
  SAVE_INCOME_STATEMENT_MAPPING_TEMPLATE,
  STORE_INCOME_STATEMENT_MAPPING_TEMPLATE,
  EXPORT_LEDGERS,
  STORE_EXPORT_LEDGERS,
  CLEAR_EXPORT_LEDGERS,
  STORE_JOURNAL_ENTRY,
  DELETE_JOURNAL_ENTRY,
  LIST_JOURNAL_ENTRIES,
  SAVE_JOURNAL_ENTRY,
  LIST_BALANCE_SHEET_MAPPING_TEMPLATE,
  SAVE_BALANCE_SHEET_MAPPING_TEMPLATE,
  STORE_BALANCE_SHEET_MAPPING_TEMPLATE,
  LIST_BALANCE_SHEET,
  STORE_BALANCE_SHEET,
  DELETE_JOURNAL_ENTRY_FROM_LEDGER,
  LIST_MARKETPLACE_PROVINCE_SUMMARY,
  STORE_MARKETPLACE_PROVINCE_SUMMARY,
  LIST_IMPORTED_FILES,
  GET_IMPORTED_FILE_ROWS,
  RENAME_IMPORTED_FILE,
  DELETE_IMPORTED_FILE,
  LIST_IMPORT_LOGS,
  DELETE_IMPORT_LOG,
  CLEAR_IMPORT_LOGS,
  GET_LEDGER_SETTING,
  STORE_LEDGER_SETTINGS,
  CLEAR_LEDGER_SETTING,
  VOID_CHEQUE,
  UNDO_CHEQUE_VOID,
  VOID_CHEQUE_SUCCESS,
  UNDO_CHEQUE_VOID_SUCCESS,
  FETCH_CARRIER_INVOICE_DETAIL_REQUEST,
  FETCH_CARRIER_INVOICE_DETAIL_SUCCESS,
  FETCH_CARRIER_INVOICE_DETAIL_FAILURE,
  CLEAR_CARRIER_INVOICE_DETAIL,
} from '../../constants/accounting';
import {UPDATE_PRICING_LISTING} from "../../constants/settings";

export const listAllTransactions = (data) => ({
    type: LIST_ALL_TRANSACTIONS,
    data
})


export const listAllLedgers = (data) => ({
    type: LIST_ALL_LEDGERS,
    data
})

export const listLedgersForSettings = (data) => ({
    type: LIST_LEDGERS_FOR_SETTINGS,
    data
})

export const storeLedgersForSettings = (ledgers) => ({
    type: STORE_LEDGERS_FOR_SETTINGS,
    ledgers
})


export const fetchTransactionsLedger = (data,callback,preview = false) => ({
    type: FETCH_TRANSACTIONS_LEDGER,
    data,
    callback,
    preview
})

export const updateLedger = (data,callback) => ({
    type: UPDATE_LEDGER,
    data,
    callback
})

export const getLedgerSettings = (data,callback) => ({
    type: GET_LEDGER_SETTING,
    data,
    callback
})

export const clearLedgerSettings = () => ({
    type: CLEAR_LEDGER_SETTING
});

export const deleteLedger = (data) => ({
    type: DELETE_LEDGER,
    data
})

export const updateEntry = (data) => ({
    type: UPDATE_ENTRY,
    data
})

export const deleteEntry = (data) => ({
    type: DELETE_ENTRY,
    data
})

export const ledgerEntries = (data,callback) => ({
    type: LEDGER_ENTRIES,
    data,
    callback
})

export const previewLedgerRefresh = (data,callback) => ({
    type: PREVIEW_LEDGER_REFRESH,
    data,
    callback
})

export const applyLedgerRefresh = (data,callback) => ({
    type: APPLY_LEDGER_REFRESH,
    data,
    callback
})

export const storeLedgerPreview = (data) => ({
    type: STORE_LEDGER_PREVIEW,
    data
})

export const clearLedgerPreview = () => ({
    type: CLEAR_LEDGER_PREVIEW
})

export const checkLedgerUpdates = (data,callback) => ({
    type: CHECK_LEDGER_UPDATES,
    data,
    callback
})

export const storeLedgerDesync = (data) => ({
    type: STORE_LEDGER_DESYNC,
    data
})

export const clearLedgerDesync = () => ({
    type: CLEAR_LEDGER_DESYNC
})

export const saveLedgerDesyncStatus = (data,callback) => ({
    type: SAVE_LEDGER_DESYNC_STATUS,
    data,
    callback
})

export const deleteLedgerByYear = (data,callback) => ({
    type: DELETE_LEDGER_BY_YEAR,
    data,
    callback
})
export const deleteLedgerByYearAndCurrency = (data,callback) => ({
    type: DELETE_LEDGER_BY_YEAR_AND_CURRENCY,
    data,
    callback
})

export const listAllCheques = (data) => ({
    type: LIST_ALL_CHEQUES,
    data
})

export const validateChequeNumber = (data,callback) => ({
    type: VALIDATE_CHEQUE_NUMBER,
    data,
    callback
})

export const listShippingSummary = (data,callback) => ({
    type: LIST_SHIPPING_SUMMARY,
    data,
    callback
})

export const listFTLSummary = (data,callback) => ({
    type: LIST_FTL_SUMMARY,
    data,
    callback
})

export const saveShippingSummarySettings = (data,callback) => ({
    type: SAVE_SHIPPING_SETTINGS,
    data,
    callback
})

export const saveStatementTaxesTemplate = (data,callback) => ({
    type: SAVE_STATEMENT_TAXES_TEMPLATE,
    data,
    callback,
})

export const listStatementTaxes = (data,callback,skipStore = false) => ({
    type: LIST_STATEMENT_TAXES,
    data,
    callback,
    skipStore
})
export const listStatementTaxesTemplate = () => ({
    type: LIST_STATEMENT_TAXES_TEMPLATE
})

// Recompute the statement of taxes (and its linked summaries) without persisting, for the
// refresh audit preview. The result is returned via callback and never written to the store.
export const previewStatementTaxes = (data,callback) => ({
    type: PREVIEW_STATEMENT_TAXES,
    data,
    callback
})
export const listShippingSettings = () => ({
    type: LIST_SHIPPING_SETTINGS
})

export const storeAllTransactions = (transactions) => ({
    type: STORE_ALL_TRANSACTIONS,
    transactions
})

export const storeAllLedgers = (ledgers) => ({
    type: STORE_ALL_LEDGERS,
    ledgers
})

export const storeLedgerSetting = (settings) => ({
    type: STORE_LEDGER_SETTINGS,
    settings
})

export const storeTransactionsLedger = (transactions) => ({
    type: STORE_TRANSACTIONS_LEDGER,
    transactions
})

export const storeLedgerEntry = (ledgerEntries) => ({
    type: STORE_LEDGER_ENTRY,
    ledgerEntries
})

export const storePredefinedEntry = (ledgerEntries) => ({
    type: STORE_PREDEFINED_ENTRY,
    ledgerEntries
})

export const storeAllCheques = (cheques) => ({
    type: STORE_ALL_CHEQUES,
    cheques
})

export const voidChequeSuccess = (updatedCheque) => ({
  type: VOID_CHEQUE_SUCCESS,
  updatedCheque,
});

export const undoChequeVoidSuccess = (updatedCheque) => ({
  type: UNDO_CHEQUE_VOID_SUCCESS,
  updatedCheque,
});

export const storeShippingSummarySettings = (rates) => ({
    type: STORE_SHIPPING_SUMMARY_SETTINGS,
    rates
})

export const storeStatementTaxesTemplate = (templates) => ({
    type: STORE_STATEMENT_TAXES_TEMPLATE,
    templates
})

export const storeAllShippingSummary = (data) => ({
    type: STORE_SHIPPING_SUMMARY,
    data
})

export const storeAllFTLSummary = (ftlSummary) => ({
    type: STORE_FTL_SUMMARY,
    ftlSummary
})

export const storeAllStatementTaxesSummary = (taxSummary) => ({
    type: STORE_STATEMENT_TAXES_SUMMARY,
    taxSummary
})

export const getInvoiceByInvoiceNumber = (invoice) => ({
    type: GET_INVOICE_BY_INVOICE_NUMBER,
    invoice
})

export const storeFoundInvoice = (invoice) => ({
    type: STORE_FOUND_INVOICE,
    invoice
})

export const saveTransaction = (data, callback) => ({
    type: SAVE_TRANSACTION,
    data,
    callback
})

export const saveLedger = (data, callback) => ({
    type: SAVE_LEDGER,
    data,
    callback
})

export const saveMarketplaceLedger = (data, callback) => ({
    type: SAVE_MARKETPLACE_LEDGER,
    data,
    callback
})


export const saveTransactionsLedger = (data, callback) => ({
    type: SAVE_TRANSACTION_LEDGER,
    data,
    callback
})

export const saveCheque = (data, callback) => ({
  type: SAVE_CHEQUE,
  data,
  callback,
});

export const importCheque = (data, callback) => ({
  type: IMPORT_CHEQUE,
  data,
  callback,
});

export const deleteTransactions = (data, callback) => ({
  type: DELETE_TRANSACTIONS,
  data,
  callback,
});
export const deleteCheques = (data, callback) => ({
    type: DELETE_CHEQUES,
    data,
    callback
})

export const voidCheque = (chequeId, callback) => ({
  type: VOID_CHEQUE,
  chequeId,
  callback,
});

export const undoChequeVoid = (chequeId, callback) => ({
  type: UNDO_CHEQUE_VOID,
  chequeId,
  callback,
});

export const assignCategory = (category,selectedEntries, callback) => ({
    type: ASSIGN_CATEGORY,
    category,
    selectedEntries,
    callback
})

export const AddTaxInfo = (taxInfo, selectedEntries) => ({
    type: ADD_TAX_INFO,
    taxInfo,
    selectedEntries,
})

export const applyTransactionsRules = (transactionIds, rules) => ({
    type: APPLY_TRANSACTIONS_RULES,
    transactionIds,
    rules,
})

export const storeUpdatedTransaction = (updatedTransaction) => ({
    type: STORE_UPDATED_TRANSACTION,
    updatedTransaction
})

export const storeUpdatedTransactions = (updatedTransactions) => ({
    type: STORE_UPDATED_TRANSACTIONS,
    updatedTransactions
})


export const storeUpdatedCheque = (updatedCheques) => ({
    type: STORE_UPDATED_CHEQUES,
    updatedCheques
})

export const storeEditingTransaction = (editingTransaction) => ({
    type: STORE_EDITING_TRANSACTION,
    editingTransaction
})

export const storeUpdatedTaxInfo = (updatedTaxInfo) => ({
    type: STORE_UPDATED_TAXINFO,
    updatedTaxInfo,
})

export const storetaxTypeWithStateProvince = (taxTypewithStateProvince) => ({
    type: STORE_TAXTYPE_WITH_STATE_PROVINCE,
    taxTypewithStateProvince
})


export const removeDeletedTransaction = (transactionId) => ({
    type: REMOVE_DELETED_TRANSACTION,
    transactionId
})

export const importTransaction = (data, callback) => ({
    type: IMPORT_TRANSACTION,
    data,
    callback
})

export const setProcessing = (processing) => ({
    type: SET_PROCESSING,
    processing
})

export const getTransactionAttachment = (data, callback) => ({
    type: GET_TRANSACTION_ATTACHMENT,
    data,
    callback
})

export const storeTransactionAttachment = (attachmentFile) => ({
    type: STORE_TRANSACTION_ATTACHMENT,
    attachmentFile
})

export const deleteTransactionAttachment = (data, callback) => ({
    type: DELETE_TRANSACTION_ATTACHMENT,
    data,
    callback
})

export const getSupplierReferences = (data) => ({
    type: GET_SUPPLIER_REFERENCES,
    data
})

export const getTransactionTaxAmount = (data, transaction, index) => ({
    type: GET_TRANSACTION_TAX_AMOUNT,
    data,
    transaction,
    index,
})

export const getTaxTypeWithStateProvince = () => ({
    type: GET_TAXTYPE_WITH_STATE_PROVINCE,
})

export const storeSupplierReferences = (references) => ({
    type: STORE_SUPPLIER_REFERENCES,
    references
})

export const listTransactionCategories = () => ({
    type: LIST_TRANSACTION_CATEGORIES,
})

export const saveTransactionCategory = (data) => ({
    type: SAVE_TRANSACTION_CATEGORY,
    data
})

export const deleteTransactionCategory = (data) => ({
    type: DELETE_TRANSACTION_CATEGORY,
    data
})

export const storeAllTransactionCategories = (data) => ({
    type: STORE_ALL_TRANSACTION_CATEGORIES,
    data
})

export const saveAndNavigateToChildTransaction = (index, transactionEdited) => ({
    type: SAVE_AND_NAVIGATE_TO_CHILD_TRANSACTION,
    index,
    transactionEdited
})

export const navigateToParentTransaction = (parentTransactionId) => ({
    type: NAVIGATE_TO_PARENT_TRANSACTION,
    parentTransactionId
})

export const startLoading = () => ({ type: START_LOADING });
export const stopLoading = () => ({ type: STOP_LOADING });

export const listPurchaseSummary = (data,callback) => ({
    type: LIST_PURCHASE_SUMMARY,
    data,
    callback
})
export const storeAllPurchaseSummary = (data) => ({
    type: STORE_PURCHASE_SUMMARY,
    data
})

export const saveNote = (data) => ({
    type: SAVE_NOTE,
    data
})

export const getNote = (data) => ({
    type: GET_NOTE,
    data
})

export const storeNote = (data) => ({
    type: STORE_NOTE,
    data
})


//trialBalance

export const listAllTrialBalance = (data) => ({
    type: LIST_ALL_TRIAL_BALANCE,
    data
})

export const fetchTrialBalance = (data,callback) => ({
    type: FETCH_TRIAL_BALANCE,
    data,
    callback
})


export const storeTrialBalance= (trialBalance) => ({
    type: STORE_TRIAL_BALANCE,
    trialBalance
})

export const listLedgerAudit = (data) => ({
    type: LIST_LEDGER_AUDIT,
    data
})

export const storeLedgerAudit = (ledgerAudit) => ({
    type: STORE_LEDGER_AUDIT,
    ledgerAudit
})

export const saveTrialBalance = (data, callback) => ({
    type: SAVE_TRIAL_BALANCE,
    data,
    callback
})

export const importMarketplaceSummary = (data, callback) => ({
    type: IMPORT_MARKETPLACE_SUMMARY,
    data,
    callback
})

export const listMarketplaceSummary = (data,callback) => ({
    type: LIST_MARKETPLACE_SUMMARY,
    data,
    callback
})

// Recompute the marketplace summary without persisting, for the refresh audit preview.
export const previewMarketplaceSummary = (data,callback) => ({
    type: PREVIEW_MARKETPLACE_SUMMARY,
    data,
    callback
})

export const marketplaceProgressSummary = (data,callback) => ({
    type: MARKETPLACE_PROGRESS_SUMMARY,
    data,
    callback
})

export const storeMarketplaceSession = (sessionId) => ({
    type: STORE_MARKETPLACE_PROGRESS_SESSION,
    sessionId,
})

export const storeMarketplaceProgressSummary = (progress) => ({
    type: STORE_MARKETPLACE_PROGRESS_SUMMARY,
    progress
})

export const storeMarketplaceSummary = (data) => ({
    type: STORE_MARKETPLACE_SUMMARY,
    data
})

export const listMarketplaceProvinceSummary = (data,callback) => ({
    type: LIST_MARKETPLACE_PROVINCE_SUMMARY,
    data,
    callback
})


export const storeMarketplaceProvinceSummary = (data) => ({
    type: STORE_MARKETPLACE_PROVINCE_SUMMARY,
    data
})

export const listImportedFiles = (callback) => ({
    type: LIST_IMPORTED_FILES,
    callback
})

export const getImportedFileRows = (data, callback) => ({
    type: GET_IMPORTED_FILE_ROWS,
    data,
    callback
})

export const renameImportedFile = (data, callback) => ({
    type: RENAME_IMPORTED_FILE,
    data,
    callback
})

export const deleteImportedFile = (data, callback) => ({
    type: DELETE_IMPORTED_FILE,
    data,
    callback
})

export const listImportLogs = (callback) => ({
    type: LIST_IMPORT_LOGS,
    callback
})

export const deleteImportLog = (data, callback) => ({
    type: DELETE_IMPORT_LOG,
    data,
    callback
})

export const clearImportLogs = (callback) => ({
    type: CLEAR_IMPORT_LOGS,
    callback
})

// INCOME STATEMENT
//trialBalance

export const listAllIncomeStatement = (data) => ({
    type: LIST_ALL_INCOME_STATEMENT,
    data
})

export const fetchIncomeStatement = (data,callback) => ({
    type: FETCH_INCOME_STATEMENT,
    data,
    callback
})


export const storeIncomeStatement = (incomeStatement) => ({
    type: STORE_INCOME_STATEMENT,
    incomeStatement
})

export const saveIncomeStatement = (data, callback) => ({
    type: SAVE_INCOME_STATEMENT,
    data,
    callback
})

export const listIncomeStatementMappingTemplate = (year) => ({
    type: LIST_INCOME_STATEMENT_MAPPING_TEMPLATE,
    year
})

export const saveIncomeStatementMappingTemplate = (data,year,currency,callback) => ({
    type: SAVE_INCOME_STATEMENT_MAPPING_TEMPLATE,
    data,
    year,
    currency,
    callback
})

export const storeIncomeStatementMappingTemplate = (templates) => ({
    type: STORE_INCOME_STATEMENT_MAPPING_TEMPLATE,
    templates
})

export const exportLedgers = (data) => ({
    type: EXPORT_LEDGERS,
    data
})

export const clearExportLedgers = () => ({
    type: CLEAR_EXPORT_LEDGERS,
})

export const storeExportLedger = (exportLedgers) => ({
    type: STORE_EXPORT_LEDGERS,
    exportLedgers
})

//BALANCE SHEET

export const listBalanceSheetMappingTemplate = (year) => ({
    type: LIST_BALANCE_SHEET_MAPPING_TEMPLATE,
    year
})

export const saveBalanceSheetMappingTemplate = (balanceSheetMappings,year,callback) => ({
    type: SAVE_BALANCE_SHEET_MAPPING_TEMPLATE,
    balanceSheetMappings,
    year,
    callback
})

export const storeBalanceSheetMappingTemplate = (templates) => ({
    type: STORE_BALANCE_SHEET_MAPPING_TEMPLATE,
    templates
})

export const listBalanceSheet = (data,callback) => ({
    type: LIST_BALANCE_SHEET,
    data,
    callback
})

export const storeBalanceSheet = (data) => ({
    type: STORE_BALANCE_SHEET,
    data
})


export const journalEntries = (data) => ({
    type: LIST_JOURNAL_ENTRIES,
    data
})

export const storeJournalEntry = (journalEntries) => ({
    type: STORE_JOURNAL_ENTRY,
    journalEntries
})

export const deleteJournalEntry = (data) => ({
    type:  DELETE_JOURNAL_ENTRY,
    data
})

export const deleteJournalEntryFromLedger = (data) => ({
    type:  DELETE_JOURNAL_ENTRY_FROM_LEDGER,
    data
})

export const saveJournalEntry = (data, callback) => ({
    type: SAVE_JOURNAL_ENTRY,
    data,
    callback
})



export const getCarrierInvoiceDetailRequest = (data) => ({
    type: FETCH_CARRIER_INVOICE_DETAIL_REQUEST,
    data,
});

export const fetchCarrierInvoiceDetailSuccess = (data) => ({
    type: FETCH_CARRIER_INVOICE_DETAIL_SUCCESS,
    data
});


export const clearCarrierInvoiceDetail = () => ({
    type: CLEAR_CARRIER_INVOICE_DETAIL,
});